import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import FilterBase from "@/components/filters/FilterBase";
import styles from "@/components/filters/SeatsFilter.module.css";
import ButtonComponent from "@/components/ui/buttons/ButtonComponent";

const SeatsFilter = () => {
  const router = useRouter();
  const buttonName = 'Seats';
  const filterName = 'seats';
  const [currentSeats, setCurrentSeats] = useState(5); // Initial seat number

  useEffect(() => {
    if (router.query.seats) {
      setCurrentSeats(Number(router.query.seats));
    }
  }, [router.query.seats]);

  const handleIncrement = () => {
    setCurrentSeats(prevSeats => prevSeats + 1);
  };

  const handleDecrement = () => {
    if (currentSeats > 1) {
      setCurrentSeats(prevSeats => prevSeats - 1);
    }
  };

  const handleFilterClick = () => {
    const {query} = router;
    router.push({
      pathname: router.pathname,
      query: {...query, seats: currentSeats},
    });
    close(); // Close the FilterBase component
  };

  return (
    <FilterBase buttonName={buttonName}>
      {({close}) => (
        <div className={styles.filters}>
          <div className={styles.subFilters}>

            <div className={styles.inputs}>
              <div className={styles.columnFilter}>
                <div className={styles.buttonFilter} onClick={handleDecrement}>
                  -
                </div>
              </div>
              <div className={styles.seats}>
                <div className={styles.seatsNumber}>{currentSeats}</div>
                <div className={styles.label}>seats</div>
              </div>
              <div className={styles.columnFilter}>
                <div className={styles.buttonFilter} onClick={handleIncrement}>
                  +
                </div>
              </div>
            </div>

            <div className={styles.controls}>


              <ButtonComponent
                icon="🔍"
                iconPosition="left"
                text="Filter"
                onClick={() => {
                  handleFilterClick();
                  close();
                }}
              />
            </div>
          </div>
        </div>
      )}
    </FilterBase>
  );
};

export default SeatsFilter;
